import { Grid, MenuItem } from '@mui/material';
import React, { ChangeEvent } from 'react';
import { transports } from '../../../../../utils/appconstants';
import { CommercialTransportInterface } from '../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';
import CountrySelector from '../../common/CountrySelector';
import CustomTextField from '../../../../CustomTextInput';

const TransportDetails = ({
    payload,
    updateField,
    errors,
    countries,
    isCountriesLoading
}: CommercialTransportInterface) => {
    return (
        <Grid container>
            <Grid item xs={12} md={12} lg={6}>
                <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[0.1rem] pb-2'>
                    <Grid
                        container
                        spacing={1}
                        sx={{
                            marginTop: '0'
                        }}
                    >
                        <Grid item xs={12} md={12} lg={6}>
                            <div className='lg:mt-4 '>
                                <CustomTextField
                                    select
                                    error={errors?.transport.length > 0}
                                    helperText={
                                        errors?.transport.length > 0
                                            ? errors?.transport
                                            : undefined
                                    }
                                    required
                                    id='commercialinvoice-transport'
                                    label='Transport'
                                    name='transport'
                                    value={payload?.transport || ''}
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'transport',
                                            e.target.value
                                        );
                                    }}
                                >
                                    {transports.map((item, index) => (
                                        <MenuItem
                                            value={item || ''}
                                            key={`transports-${item}-${index}`}
                                        >
                                            {item}
                                        </MenuItem>
                                    ))}
                                </CustomTextField>
                            </div>
                        </Grid>

                        <Grid item xs={12} md={12} lg={6}>
                            <div className='lg:mt-4 mt-2'>
                                <CustomTextField
                                    error={errors?.voyageNumber.length > 0}
                                    helperText={
                                        errors?.voyageNumber.length > 0
                                            ? errors?.voyageNumber
                                            : undefined
                                    }
                                    id='proformainvoice-voyageNumber'
                                    label='Voyage Number (Optional)'
                                    name='voyageNumber'
                                    value={payload?.voyageNumber || ''}
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'voyageNumber',
                                            e.target.value
                                        );
                                    }}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Grid>

            <Grid item xs={12} md={12} lg={6}>
                <div className='lg:border border-appcolorgreyfaint lg:px-[1rem] lg:pt-[0.1rem] pb-2'>
                    <Grid
                        container
                        spacing={1}
                        sx={{
                            marginTop: 0
                        }}
                    >
                        <Grid item xs={12} md={12} lg={6}>
                            <div className='lg:mt-4 '>
                                <CustomTextField
                                    placeholder='Place'
                                    error={errors?.finalDestination.length > 0}
                                    helperText={
                                        errors?.finalDestination.length > 0
                                            ? errors?.finalDestination
                                            : undefined
                                    }
                                    required
                                    id='proformainvoice-finalDestination'
                                    label='Final Destination'
                                    name='finalDestination'
                                    value={payload?.finalDestination || ''}
                                    onChange={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'finalDestination',
                                            e.target.value
                                        );
                                    }}
                                />
                            </div>
                        </Grid>

                        <Grid item xs={12} md={12} lg={6}>
                            <div className='lg:mt-4 mt-2'>
                                <CountrySelector
                                    error={
                                        errors?.countryOfFinalDestinationId
                                            .length > 0
                                    }
                                    helperText={
                                        errors?.countryOfFinalDestinationId
                                            .length > 0
                                            ? errors?.countryOfFinalDestinationId
                                            : undefined
                                    }
                                    changeFunction={(
                                        e: ChangeEvent<HTMLInputElement>
                                    ) => {
                                        updateField(
                                            'countryOfFinalDestinationId',
                                            e.target.value
                                        );
                                        updateField(
                                            'countryOfFinalDestinationName',
                                            countries.filter(
                                                (item: {
                                                    id: string | number;
                                                }) =>
                                                    item?.id === e.target.value
                                            )[0]?.name
                                        );
                                    }}
                                    value={
                                        payload?.countryOfFinalDestinationId ||
                                        ''
                                    }
                                    id='commercialinvoice-countryOfFinalDestinationId'
                                    label='Country Of Final Destination'
                                    name='countryOfFinalDestinationId'
                                    {...{ isCountriesLoading, countries }}
                                    gridWidth={12}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </Grid>
        </Grid>
    );
};

export default TransportDetails;
